import { FeatureFlag } from '@ps/web-core-enums';
import { type Page, useFeature } from '@ps/web-core-store';
import React from 'react';

import StarsLayoutBase from './StarsLayoutBase';
import StarsLayoutV2 from './StarsLayoutV2';

const StarsLayout: React.FC<Page> = (page) => {
  const isNavV2Enabled = useFeature(FeatureFlag.PKRNavDesignV2);

  return isNavV2Enabled ? <StarsLayoutV2 {...page} /> : <StarsLayoutBase {...page} />;
};

export default StarsLayout;
